module.exports = __webpack_public_path__ + "static/media/icon_twitter.8897fad5.svg";